module.exports = __webpack_public_path__ + "static/assets/44e4859e354c81d66c73f741df2e5ec7.svg";